import { render, staticRenderFns } from "./PendingApproval.vue?vue&type=template&id=5c34e29c&"
import script from "./PendingApproval.vue?vue&type=script&lang=js&"
export * from "./PendingApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports